// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"pg-service-order-history-common":"643b6530a0009286ac33","OrderHistoryInTransit":"1a7f9badd8300ed3ceb9","OrderHistoryLatestOrder":"ebe4231e0f62a6ca8f4f","OrderHistoryOrderInformation":"5264d31a766e53fe47dd","OrderHistoryOrdersList":"1fb5cf2c74d12412746f"}[chunkId] + ".bundle.js";
};